"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSFORMATIONS_MAP = exports.TransformationType = void 0;
var TransformationType;
(function (TransformationType) {
    TransformationType["TRIM"] = "TRIM";
    TransformationType["CAPITALIZE"] = "CAPITALIZE";
    TransformationType["ROUND"] = "ROUND";
})(TransformationType = exports.TransformationType || (exports.TransformationType = {}));
exports.TRANSFORMATIONS_MAP = {
    TRIM: {
        name: "trim",
        description: "Remove any spaces, newlines, etc. at the beginning and end of the value",
        arguments: []
    },
    CAPITALIZE: {
        name: "capitalize",
        description: "Capitalize the text",
        arguments: [{
                name: "mode",
                description: "capitalization mode (word, sentence, lowercase, allcaps)",
                mandatory: false,
                defaultValue: "word",
                type: "string"
            }]
    },
    ROUND: {
        name: "round",
        description: "Round to the nearest number",
        arguments: [
            {
                name: "precision",
                description: "number of digits to which you want to round the number",
                mandatory: false,
                defaultValue: 0,
                type: "number"
            }
        ]
    }
};
//# sourceMappingURL=transformation.js.map